import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import Input from "../../../../hiberUiKit/src/atoms/Input/Input";
import {none, option, Option} from "ts-option";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import PartnerBrandPoints from "../../../../model/partnerBrand/PartnerBrandPoints";

interface Props {
	onClose: () => void
	onCreate: (point: PartnerBrandPoints) => void
}

interface State {
	amount: Option<number>
	description: Option<string>
}

export default class CreatePartnerBrandPointsModal extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {amount: none, description: none};
		this.onDescriptionChange = this.onDescriptionChange.bind(this);
		this.onAmountChange = this.onAmountChange.bind(this);
		this.onDone = this.onDone.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} mediumWidth title={"Add reward points"}>
				<FormGroup label={"Amount"}>
					<Input type={"number"}
						   value={this.state.amount.getOrElse(undefined)}
						   onChange={this.onAmountChange}/>
				</FormGroup>
				<FormGroup label={"Description"}>
					<Input type={"text"}
						   value={this.state.description.getOrElse(undefined)}
						   onChange={this.onDescriptionChange}/>
				</FormGroup>
				<FormButtonsView align={"right"}>
					<div className="pull-left">
						<ButtonTertiary label="Cancel" onClick={this.props.onClose}/>
					</div>
					<ButtonPrimary label={"Done"}
								   onClick={this.onDone}
								   disabled={this.state.amount.isEmpty}/>
				</FormButtonsView>
			</Modal>
		)
	}

	onDescriptionChange(event: React.ChangeEvent<HTMLInputElement>) {
		const value = event.target.value;
		this.setState({description: value.length ? option(value) : none});
	}

	onAmountChange(event: React.ChangeEvent<HTMLInputElement>) {
		if (event.target.value.trim() === "") {
			this.setState({amount: none});
			return
		}
		const number = Number(event.target.value);
		if (!isNaN(number) && number !== 0) {
			this.setState({amount: option(number)});
		}
	}

	onDone() {
		this.props.onCreate(PartnerBrandPoints.createNew(this.state.amount.get, this.state.description));
		this.props.onClose();
	}
}